import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

interface Props {
  value: string;
  label: string;
}

export default function StatCounter({ value, label }: Props) {
  const { ref, inView } = useInView({ triggerOnce: true });
  const [displayed, setDisplayed] = useState("0");

  useEffect(() => {
    if (!inView) {
      return;
    }

    const num = parseFloat(value.replace(/[^0-9.]/g, ""));
    const prefix = value.match(/^[^0-9]*/)?.[0] || "";
    const suffix = value.match(/[^0-9.]+$/)?.[0] || "";

    if (Number.isNaN(num)) {
      setDisplayed(value);
      return;
    }

    let start = 0;
    const duration = 1500;
    const step = 16;
    const increment = num / (duration / step);
    const timer = window.setInterval(() => {
      start = Math.min(start + increment, num);
      setDisplayed(
        `${prefix}${Number.isInteger(num) ? Math.floor(start) : start.toFixed(1)}${suffix}`
      );
      if (start >= num) {
        window.clearInterval(timer);
      }
    }, step);

    return () => {
      window.clearInterval(timer);
    };
  }, [inView, value]);

  return (
    <div ref={ref} style={{ textAlign: "center", padding: "0 clamp(10px, 2vw, 40px)" }}>
      <div
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: "clamp(48px, 6vw, 80px)",
          color: "#D4A843",
          lineHeight: 1,
          marginBottom: 12,
        }}
      >
        {displayed}
      </div>
      <div
        style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 700,
          fontSize: 16,
          letterSpacing: "0.1em",
          color: "#908A83",
          textTransform: "uppercase",
        }}
      >
        {label}
      </div>
    </div>
  );
}
